var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfigurationEditor',{attrs:{"id":_vm.$route.query.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }